import React from 'react';
import { Breadcrumbs, Link as MLink, Typography, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useTranslation } from 'react-i18next';

const pathLabelMap = {
  'dashboard': 'Dashboard',
  'products': 'Products',
  'categories': 'Categories',
  'inventory': 'Inventory',
  'users': 'Users',
  'client-orders': 'Client Orders',
  'invoices': 'Invoices',
  'reporting': 'Reports',
  'my-company': 'My Company',
  'profile': 'My Profile',
  'cart': 'Shopping Cart',
  'my-orders': 'My Orders'
};

function titleCase(str) {
  return str
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
}

const BreadcrumbsBar = ({ extraTrail }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [, forceRerender] = React.useState(0);

  React.useEffect(() => {
    const handleLabelUpdate = () => forceRerender((v) => v + 1);
    window.addEventListener('breadcrumb-label-update', handleLabelUpdate);
    return () => window.removeEventListener('breadcrumb-label-update', handleLabelUpdate);
  }, []);

  const pathnames = location.pathname.split('/').filter((x) => x);

  const resolveDynamicLabel = (segment) => {
    // If it looks like an object id (product/inventory detail), try a cached friendly name
    const isObjectId = /^[a-f0-9]{24}$/i.test(segment);
    if (!isObjectId) return null;
    try {
      const cached = sessionStorage.getItem(`breadcrumb:${segment}`);
      return cached || null;
    } catch {
      return null;
    }
  };

  return (
    <Box sx={{ mt: '10px', mb: 2 }}>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <MLink component={Link} underline="hover" color="inherit" to="/">
          {t('Home')}
        </MLink>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === pathnames.length - 1;
          const dynamicLabel = resolveDynamicLabel(value);
          const labelKey = dynamicLabel || pathLabelMap[value] || titleCase(value);

          return isLast ? (
            <Typography color="text.primary" key={to}>
              {t(labelKey)}
            </Typography>
          ) : (
            <MLink component={Link} underline="hover" color="inherit" to={to} key={to}>
              {t(labelKey)}
            </MLink>
          );
        })}
        {extraTrail && (
          <Typography color="text.primary">{extraTrail}</Typography>
        )}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbsBar;
